import { render, staticRenderFns } from "./VPanel.vue?vue&type=template&id=c122995a&"
import script from "./VPanel.vue?vue&type=script&lang=ts&"
export * from "./VPanel.vue?vue&type=script&lang=ts&"
import style0 from "./VPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports